<template>
  <div id="app">
    <keep-alive>
      <router-view v-if='$route.meta.keepAlive'/>
    </keep-alive>
    <router-view v-if='!$route.meta.keepAlive'/>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: 'App',
  data(){
    return{
      aa:'',
      theme:{}
    }
  },
   computed: {
    ...mapState(["loginState"])
  },
   mounted() {
    // this.gettheme()
  },
  methods:{
    // gettheme() {
    //   const self = this;
    //   this.$api.method
    //     .getWebsite()
    //     .then(res => {
    //       if (res != this.global.apiError) {
    //         self.theme = res.recData;
    //         let themedata = self.theme
    //         this.savetheme(themedata)
    //         this.hf();
    //         this.setIco(res.recData);
    //       }
    //     });
    // },
    ...mapMutations(["savetheme"]),
   hf(){
      let aa = this.theme.colour
      document.documentElement.style.setProperty(`--zt-color`, aa);
   },
   setIco (item) {
     //创建一个<link>标签
     var head = document.getElementsByTagName('head')[0];
     var linkTag = document.createElement('link');
     //配置<link>标签的相关属性
     linkTag.setAttribute("rel", "Shortcut Icon")
     linkTag.setAttribute("type", "image/x-icon")
     var ico = item.icoImg;
     document.getElementsByTagName("title")[0].innerText = item.name;
     linkTag.href = ico;
     head.appendChild(linkTag);
   }
  }
}

</script>

<style>
#app {
  font-family: 'Microsoft YaHei', Helvetica, Arial, sans-serif;
}
.el-carousel__button{
  width: 5px !important;
  height: 5px !important;
  border-radius: 50% !important;;
}
:root {
    --zt-color:transparent;
    /* --zt-color:#ed1b24 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue